import type { CSSProperties } from "react";
import { BADGE_TONI, type StatoTone } from "@/features/ordini/components/statoToni";

export function SidebarFilter({
  active,
  onClick,
  label,
  tono,
  count,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
  tono: StatoTone;
  count?: number;
}) {
  // Come i chip della lista ordini: spento bianco con il pallino del suo
  // colore, acceso pieno di quel colore. Il tono passa da `--tono` perche' il
  // JIT di Tailwind non vede i colori composti a runtime.
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      style={{ "--tono": BADGE_TONI[tono] } as CSSProperties}
      className={[
        "flex h-9 w-full items-center gap-2 rounded-full border px-3 text-left text-[12.5px] font-semibold transition-[background-color,color,border-color] duration-150 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-4",
        active
          ? "border-[color:var(--tono)] bg-[color:var(--tono)] text-white"
          : "border-transparent text-ink hover:border-[color:var(--tono)] hover:bg-[color:color-mix(in_srgb,var(--tono)_6%,rgb(var(--om-card)))]",
      ].join(" ")}
    >
      <span
        className={[
          "h-2 w-2 shrink-0 rounded-full",
          active ? "bg-card" : "bg-[color:var(--tono)]",
        ].join(" ")}
        aria-hidden="true"
      />
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {count !== undefined && (
        <span
          className={[
            "min-w-[1.25rem] shrink-0 rounded-full px-1.5 text-center text-[11.5px] font-bold tabular-nums",
            active ? "bg-white/20" : "bg-paper-2",
          ].join(" ")}
        >
          {count}
        </span>
      )}
    </button>
  );
}
